export default __webpack_public_path__ + "static/media/premium.13e9c4c6.JPG";